import { render } from "./IconCircle.vue?vue&type=template&id=21e712ef&scoped=true"
import script from "./IconCircle.vue?vue&type=script&lang=js"
export * from "./IconCircle.vue?vue&type=script&lang=js"

import "./IconCircle.vue?vue&type=style&index=0&id=21e712ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e712ef"]])

export default __exports__